import { inject, observer } from "mobx-react";
import * as React from "react";
import { Notice } from "telia-front-react";
import ErrorUtil from "../utils/ErrorUtil.mjs";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  componentDidCatch(error, errorInfo) {
    const { onErrorCaught } = this.props;
    this.setState({ hasError: true });
    ErrorUtil.registerError(error, errorInfo);
    if (onErrorCaught) {
      onErrorCaught(error);
    }
  }
  render() {
    const { translate } = this.props.translateStore;
    if (this.state.hasError) {
      return /* @__PURE__ */ React.createElement(Notice, { type: "error" }, translate("payment.errors.component-error"));
    }
    return this.props.children;
  }
}
const ErrorBoundary$1 = inject("translateStore")(observer(ErrorBoundary));
export {
  ErrorBoundary$1 as default
};
